<template>
  <v-card>
    <v-card-title>
      <v-spacer/>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="errorLog"
      :search="search"
      item-key="errorID"
      hide-actions
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.details.message }}</td>
          <td> {{ props.item.stamp }} </td>
        </tr>
      </template>
      <template
        slot="expand"
        slot-scope="props"
      >
        <pre>
          {{ props.item.details }}
        </pre>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Title',
          value: 'title',
          sortable: false
        },
        {
          text: 'Message',
          value: 'details.message',
          sortable: false
        },
        {
          text: 'Timestamp',
          value: 'stamp',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      errorLog: 'reports/errorLog'
    })
  },
  mounted () {
    this.getErrorLog()
  },
  methods: {
    ...mapActions({
      getErrorLog: 'reports/getErrorLog'
    })
  }
}
</script>

<style scoped>
pre {
  width: 100%;
  overflow: scroll;
  text-align: left;
  background: black;
  color: white;
}
</style>
